export const COMMUNITY_CODE_OF_CONDUCT_COOKIE = 'communityCodeOfConduct';
export const INVALID_PHONE_NUMBER = 'Invalid phone number. Please use a valid Australian phone number.';
export const CUSTOM_FIELD_ID = 37;